import { Components, createTheme } from '@mui/material';
import { AppTheme } from '../models/Theme';
import { theme } from './appTheme';

const createOverrides = (palette: any):{ components: Components } => ({
  components: {
    MuiCollapse: {
      styleOverrides: {
        entered: {
          height: 'auto',
          overflow: 'visible'
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginTop: '24px'
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: '14px',
          '&$disabled': {
            color: 'unset'
          }
        },
        disabled: {}
      }
    },
    MuiInputBase: {
      styleOverrides: {
        inputMultiline: {
          lineHeight: '1.5em'
        },
        input: {
          '&::placeholder': {
            opacity: 0.15
          },
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        '@global': {
          body: {
            fontFeatureSettings:
              '"dlig" 0, "numr" 0, "dnom" 0, "tnum" 0, "case" 0, "zero" 0, "frac" 0, '
              + '"sups" 0, "subs" 0, "cpsp" 0, "salt" 0, "ss01" 0, "ss02" 0, "ss03" 0, '
              + '"cv01", "cv02", "cv03", "cv04", "cv05", "cv06", "cv07", "cv08", "cv09", '
              + '"cv10", "cv11", "calt", "liga", "kern"'
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          '@media (min-width: 600px)': {
            minHeight: '36px'
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontWeight: 400
        },
        head: {
          fontWeight: 600,
          color: palette.text.secondary,
          lineHeight: '1.3rem',
          fontSize: '0.75rem',
          padding: '14px 40px 14px 16px'
        }
      }
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          '&:hover': {
            color: palette.text.primary
          },
          '&$active': {
            color: palette.text.primary
          }
        },
        active: {},
        icon: {
          fontSize: '18px'
        }
      }
    }
  }
});

const commonTypography = {
  typography: {
    fontFamily: 'Merriweather, sans-serif',
    fontFamily2: 'Port Lligat Slab, sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    body2: {
      fontWeight: 300
    },
    body1: {
      fontWeight: 300
    },
    caption: {
      fontWeight: 300
    },
    h2: {
      fontFamily: 'Port Lligat Slab, sans-serif',
    },
    h3: {
      fontFamily: 'Port Lligat Slab, sans-serif',
    },
    h4: {
      fontFamily: 'Port Lligat Slab, sans-serif',
    },
    h5: {
      fontFamily: 'Port Lligat Slab, sans-serif',
    },
  },
};

// Default Theme

const defaultThemePalette = {
  primary: {
    main: '#f7941d',
    contrastText: '#fff'
  },
  background: {
    default: '#fbf9f0'
  },
  secondary: {
    main: '#4b6390'
  },
  text: {
    secondary: 'rgba(0, 0, 0, 0.54)',
    primary: 'rgba(0, 0, 0, 0.87)'
  },
};

export const defaultTheme = createTheme({
  palette: defaultThemePalette,
  ...commonTypography,
  ...theme.default,
  ...createOverrides(defaultThemePalette)
}) as AppTheme;



export const getTheme = (): AppTheme => defaultTheme;

export const useTheme = () => ({
  ...getTheme()
});
